import React from 'react';
import ReUsableBanner from '../../../../components/common/ReUsableBanner';
import CountUpCards from '../Homepage/CountUpCards';
import BookNowForm from '../Homepage/BookNowForm';
import AnniversaryCard from './AnniversaryCard';

const AboutUsBanner = () => {
	const asideImage = '/assets/about-us-banner.png';
	const smallTitle = 'About Us';
	const headerContent = 'Bringing People Together with Great Food!';
	const paraContent = `At Chakaravarthy Catering Center, we specialize in creating delicious and memorable dining experiences for every occasion. With fresh ingredients, expert chefs, and a passion for excellence, we make your celebrations truly special!`;

	return (
		<div>
			<ReUsableBanner
				asideImage={asideImage}
				smallTitle={smallTitle}
				headerContent={headerContent}
				paraContent={paraContent}
			/>
			<AnniversaryCard />
			<CountUpCards />
			<BookNowForm />
		</div>
	);
};

export default AboutUsBanner;
